import { action } from 'easy-peasy';
import { IActionSetVisit } from '../types';

const setVisit: IActionSetVisit = action((state, visit) => {
  state.current = visit;
});

export default setVisit;
